export function round(num: number) {
    return Math.round(num * 100) / 100;
}
